// extracted by mini-css-extract-plugin
export var eyebrow = "_c0-3";
export var heroImage = "_c0-4";
export var main = "_c0-2";
export var modal = "_c0-0";
export var shell = "_c0-1";